import { Unit } from '../Proto/dcei_engine_unit_proto';
import { Weapon } from '../Proto/dcei_engine_weapon_proto';
import { Ability } from '../Proto/dcei_engine_ability_proto';
import { Behavior } from '../Proto/dcei_engine_behavior_proto';
import { SpawnWave } from '../Proto/dcei_engine_spawn_wave_proto';
import { CameraSettings } from '../Proto/dcei_engine_spawn_wave_proto';

const defaults = new Map();

// BEGIN-GENERATED
defaults.set(Unit, Unit.fromJson(
{ "components": { "unitStats": { "radius": 0.2, "ground": true, "selectable": true, "targetPriority": 10 }, "mana": { "startMana": -1 }, "shield": { "startShield": -1 }, "turning": { "turningSpeed": 720 } } }
));
defaults.set(Weapon, Weapon.fromJson(
{ "criticalChance": 0, "stats": { "preSwing": 0.5, "backSwing": 0.5, "period": 1, "minimalRange": 0, "range": 3, "scanRange": 3 }, "distanceCheckMode": "CHECK_CLOSEST_EDGE", "distanceExtendMode": "INCLUDE_SOURCE_UNIT_RADIUS", "targetFilter": { "primarySortKeys": { "key": "DISTANCE_TO_SEARCH_CENTER", "order": "LOWEST_FIRST" }, "player": "EXCLUDED", "ally": "EXCLUDED", "missile": "EXCLUDED", "stealth": "EXCLUDED", "invulerable": "EXCLUDED", "alive": "REQUIRED" } }
));
defaults.set(CameraSettings, CameraSettings.fromJson(
{ "focalPointX": 16, "focalPointY": 16, "allowZoom": true, "allowPanX": true, "allowPanY": true, "panAreaCenterX": 16, "panAreaCenterY": 17, "panAreaLengthX": 23.272319793701172, "skipIntroSequence": false }
));
defaults.set(Behavior, Behavior.fromJson(
{ "periodicEffectCount": -1 }
));
defaults.set(Ability, Ability.fromJson(
{ "stats": { "maxCharge": 1 }, "distanceCheckMode": "CHECK_CLOSEST_EDGE", "distanceExtendMode": "INCLUDE_SOURCE_UNIT_RADIUS" }
));
defaults.set(SpawnWave, SpawnWave.fromJson(
{ "callWaveCountdown": 30 }
));
export default defaults;
